import React from 'react';
import validate from 'validate.js';
import { get } from 'lodash';
import { FormattedMessage } from 'react-intl';

const validateSyncChoices = (values) => {
  const {
    cannot_sync_reasons,
    other_selected: otherSelected,
    other_reason
  } = values || {};

  return {
    cannot_sync_reasons: otherSelected ? undefined : validate.single(cannot_sync_reasons,
      {
        presence: { allowEmpty: false }
      }),
    ...(otherSelected && {
      other_reason: validate.single(other_reason,
        {
          presence: { allowEmpty: false }
        })
    })
  };
};

export default validateSyncChoices;
